import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CreateUserNoteInput, UpdateUserNoteInformationInput, UserNoteFilterInput } from './inputs';
import { UserNoteResource, UserNoteListItemResource } from './resources';
import { CollectionResource } from '@app/data/resources';
import { CursorPaginationInput } from '@app/data/inputs';
import { UserNoteRef } from './refs';

export default class UserNote {
    private basePath = '/api/user-note';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of user notes
    get = async (
        pagination: CursorPaginationInput,
        filter: UserNoteFilterInput
    ): Promise<CollectionResource<UserNoteListItemResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Get user note by ID
    getById = async (id: ID): Promise<UserNoteResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Create new user note
    create = async (input: CreateUserNoteInput): Promise<UserNoteRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Patch user note info
    update = async (id: ID, input: UpdateUserNoteInformationInput): Promise<UserNoteRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);

        return data;
    };

    // Archive note
    archive = async (id: ID): Promise<UserNoteRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);

        return data;
    };

    // Restore archived user note
    restore = async (id: ID): Promise<UserNoteRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/restore`);

        return data;
    };
}
